// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container_1yQEW","content":"App_content_pIJBB App_container_1yQEW","header":"App_header_3qzuo","sidebar":"App_sidebar_3dMLz"};